import { combineReducers } from 'redux';
import { combineEpics, Epic } from 'redux-observable';
import { createSelectorHook } from 'react-redux';

import { userReducer, UserState } from './user/reducer';
import { userEpics } from './user/epics';

import { passwordReducer, PasswordState } from './password/reducer';
import { passwordEpics } from './password/epics';

export interface State {
  user: UserState;
  password: PasswordState;
}

export const createRootReducer = () =>
  combineReducers({
    user: userReducer,
    password: passwordReducer,
  });

const rootEpics = [...userEpics, ...passwordEpics] as Epic[];
export const rootEpic = combineEpics(...rootEpics);

export const useTypedSelector = createSelectorHook<State>();
